module.exports = __webpack_public_path__ + "img/account_tree.d9d0ef4e.svg";